import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'ha/i18n';

import { logout } from 'ha/modules/AuthLogic/actions';
import { getIsAuthenticated } from 'ha/modules/AuthLogic/selectors';

import { LISTING_DETAIL_PAGE, SEARCH } from 'ha/constants/pageNames';
import { usePage } from 'ha/modules/Page/contexts/PageContext';
import MobileMainMenu from '../components/MobileMainMenu';

type Props = {
  showDrawerMenu?: boolean;
};

export const MobileMainMenuContainer: React.FC<Props> = ({
  showDrawerMenu = true,
}) => {
  const isAuthenticated = useSelector(getIsAuthenticated);

  const dispatch = useDispatch();
  const { urlResolver } = useIntl();
  const { category } = usePage();
  const shouldNotRedirect = React.useMemo(
    () => category && [SEARCH, LISTING_DETAIL_PAGE].includes(category),
    [category],
  );
  const handleLogout = React.useCallback(() => {
    dispatch(logout(shouldNotRedirect ? undefined : urlResolver.getHomeUrl()));
  }, []);

  return (
    <MobileMainMenu
      isAuthenticated={isAuthenticated}
      logout={handleLogout}
      showDrawerMenu={showDrawerMenu}
    />
  );
};

export default MobileMainMenuContainer;
